export enum LOCALES {
  EN = 'en',
  ES = 'es',
}
